<template>
    <img src="@/assets/logo.png" alt="Logo" class="size-32" />
</template>
<style scoped>
.size-16 {
    width: 48px;
    height: 48px;
}
</style>